import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#10B981', '#3B82F6', '#EF4444', '#F59E0B'];

const ProfitabilityAnalysis = ({ data }) => {
    if (!data || !data.summary) return null;

    const s = data.summary;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Profitability & Cost Analysis</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Revenue</small>
                            <strong className="text-primary">{s.total_revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Cost</small>
                            <strong className="text-danger">{s.total_cost?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Gross Profit</small>
                            <strong className={s.gross_profit >= 0 ? 'text-success' : 'text-danger'}>
                                {s.gross_profit?.toLocaleString(undefined, { minimumFractionDigits: 3 })}
                            </strong>
                        </div>
                    </div>
                    <div className="col-6 mt-2">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Material Cost</small>
                            <strong>{s.material_cost?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-6 mt-2">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Labour Cost</small>
                            <strong>{s.labour_cost?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                </div>
                <div className="text-center mb-3">
                    <span className="badge bg-success fs-6 p-2">
                        Gross Margin: {s.gross_margin}%
                    </span>
                </div>
                {data.by_location && data.by_location.length > 0 && (
                    <>
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Gross Profit by Location</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Location</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="text-end">Cost</th>
                                        <th className="text-end">Profit</th>
                                        <th className="text-end">Margin</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_location.map((loc, i) => (
                                        <tr key={i}>
                                            <td>{loc.location_name}</td>
                                            <td className="text-end">{loc.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{loc.total_cost?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end" style={{ color: loc.gross_profit >= 0 ? '#2e7d32' : '#c62828' }}>
                                                {loc.gross_profit?.toLocaleString(undefined, { minimumFractionDigits: 3 })}
                                            </td>
                                            <td className="text-end">{loc.gross_margin}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ProfitabilityAnalysis;
